// MessageList
import Moment from 'moment';
import React from 'react';
import ReactDom from 'react-dom';
import _ from 'lodash';
import { connect } from 'react-redux';

import DomUserPicture from './DomUserPicture';
import Message from './Message';
import MessageForm from './MessageForm';
import MessageTypers from './MessageTypers';
import ScrollTarget from './ScrollTarget';
import { getTranslator } from '../locales';
import { select as selectFilter } from '../redux/actions/filtersAction';

@connect((Store) => {
  const t = getTranslator();
  const categories = Store.filters.categories;

  let selectedCategory = null;
  if (Store.threads.selectedThread.categoryId) {
    selectedCategory = _.filter(
      categories,
      category => (category.id === Store.threads.selectedThread.categoryId)
    )[0];
  }

  return {
    locale: Store.settings.locale,
    labels: {
      T_HOUR: t.t('hr'),
      T_JUST_NOW: t.t('just now'),
      T_MINUTE: t.t('min'),
      QUESTION_TOPIC: t.t(
        'in topic %{topic}',
        { topic: '<em class="brandedColor_color">' + selectedCategory.name + '</em>',
          interpolation: { escapeValue: false } })
    },
    categories,
    selectedCategory,
    luser: Store.luser,
    selectedThread: Store.threads.selectedThread,
    typers: Store.threads.typers
  }
})

export default class MessageList extends React.Component {
  constructor() {
    super();
    this.rectHeight = 0;
    this.state = { thread_id: null }
  }

  categoryClick(category) {
    this.props.dispatch(selectFilter(category));
    this.props.mobilePanelChange('threads');
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.selectedThread.id !== this.state.thread_id){
      this.rectHeight = 0;
      this.setState({ thread_id: nextProps.selectedThread.id })
    } else {
      const rect = ReactDom.findDOMNode(this).getClientRects();
      this.rectHeight = rect[0].height;
    }
  }

  render() {
    const momentDuration = Moment.duration(
      Moment().diff(this.props.selectedThread.createdAt)
    );
    const minElapsed = momentDuration.asMinutes();

    let elapsedSinceCreated = '';

    if (minElapsed < 1) {
      elapsedSinceCreated = this.props.labels.T_JUST_NOW;
    } else if (minElapsed < 60) {
      elapsedSinceCreated = `${momentDuration.minutes()} ${this.props.labels.T_MINUTE}`;
    } else {
      elapsedSinceCreated = `${_.round(momentDuration.asHours(), 0).toLocaleString(this.props.locale)} ${this.props.labels.T_HOUR}`;
    }

    const threadMessages = this.props.selectedThread.messages ? this.props.selectedThread.messages : [];

    return (
      <div className={this.props.mobilePanelClassName('messages')+' brandedColorLight_bg'}>
        <div className='heading'>
          <div className='picture'>
            <DomUserPicture user={this.props.selectedThread.author} isInsider={false} size='s' />
            <span className='date'>{elapsedSinceCreated}</span>
          </div>
          <h2 className='brandedColor_color'>
            <span className='name'>{this.props.selectedThread.author ? this.props.selectedThread.author.name : ''}</span>
            {this.props.selectedThread.question}
            {
              (() => {
                if (this.props.selectedCategory) {
                  return <span
                    className='category'
                    onClick={this.categoryClick.bind(this, 'cat' + this.props.selectedCategory.id)}
                    dangerouslySetInnerHTML={{ __html: this.props.labels.QUESTION_TOPIC }}>
                  </span>
                }
              })()
            }
          </h2>
          <div className='clear'></div>
        </div>
        <div className='messages-list'>
          {
            // if initial question as a description attached
            (() => {
              if (this.props.selectedThread.description){
                return <Message
                  key={'msg-intro'}
                  message={{
                    author: this.props.selectedThread.author,
                    body: this.props.selectedThread.description,
                    createdAt: this.props.selectedThread.createdAt
                  }}
                  isOwn={(this.props.selectedThread.author.id == this.props.luser.id)}
                  typing={false}
                />
              }
            })()
          }
          {
            // all the messages of the thread
            threadMessages && threadMessages.map((message, i) => {
              return (
                <Message
                  key={'msg'+i}
                  message={message}
                  isOwn={(message.author.id == this.props.luser.id)}
                  typing={false}
                />
              );
            })
          }
          <MessageTypers />
          <ScrollTarget
            numElements={threadMessages.length + this.props.typers.length}
            parentHeight={this.rectHeight}
          />
        </div>
        <MessageForm />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/MessageList.jsx